export const CONTENT_CARD_TEST_IDS = {
  card: {
    root: 'page-content-card-container',
    contentContainer: 'page-content-card-content-container',
    inspectButton: 'page-content-card-inspect-button'
  },
  header: {
    root: 'page-content-card-header',
    slug: 'page-content-card-slug',
    slugContainer: 'page-content-card-slug-container',
    menuContainer: 'page-content-card-menu-container',
    slotContainer: 'page-content-card-slot-container',
    controlIcons: 'page-content-card-control-icons',
    slot1: 'page-content-card-slot1',
    menuTrigger: 'page-content-ellipsis-icon'
  },
  content: {
    root: 'page-content-card-content-root',
    headline: 'content-card-headline-label',
    byline: 'content-card-byline-label',
    body: 'content-card-body-label',
    curationContainer: 'content-card-curation-container',
    curationImage: 'content-card-curation-image',
    imageContainer: 'content-card-image-container',
    thumbnail: 'thumbnail'
  },
  footer: {
    root: 'page-content-card-footer',
    info: 'page-content-card-footer-info',
    icons: 'page-content-card-footer-icons',
    text: 'page-content-card-footer-text'
  },
  collaborators: {
    root: 'page-content-card-collaborators',
    owners: 'page-content-card-collaborators-owners',
    editors: 'page-content-card-collaborators-editors'
  },
  generic: {
    root: 'page-content-card-generic'
  }
} as const;
